"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REJECTED_PHOTO_PLACEHOLDER_URL = void 0;
/**
 * Profile photo shown in place of one an admin removed (Admin › User › Edit Photo › Remove Photo).
 * Served by the website (frontend/public/images). A real URL keeps every app version on its normal
 * path (no "missing photo" onboarding); users with isPhotoRejectedByAdmin are asked to upload a new one.
 */
exports.REJECTED_PHOTO_PLACEHOLDER_URL = 'https://ivyapp.com/images/photo-removed-avatar.png';
//# sourceMappingURL=photo.js.map